import AmountWithCurrency, { IAmountWithCurrencyDto } from 'models/AmountWithCurrency';
import { Lmid, Guid } from "@/types";

export interface IInvoiceAdditionalLmidToAssign {
    assetId: Guid,
    lmid: string,
    assetVersion?: number,
    isCurrentVersion?: boolean
}
export interface IGetInvoiceAdditionalAssetToAssignDto {
    assetId: Guid
    articleId: Guid
    articleDescription: string
    lmid: Lmid
    referenceValue?: IAmountWithCurrencyDto | null
    isAssetLabeled: boolean
    assetVersion: number
    isCurrentVersion: boolean
    supplierOrderNumber: string
    internalOrderNumber?: string | null
}

export default class InvoiceAdditionalAssetToAssign {
    assetId: Guid
    articleId: Guid
    articleDescription: string
    lmid: Lmid
    referenceValue?: AmountWithCurrency | null
    isAssetLabeled: boolean
    assetVersion: number
    isCurrentVersion: boolean
    supplierOrderNumber: string
    internalOrderNumber?: string | null

    constructor(dto: IGetInvoiceAdditionalAssetToAssignDto) {
        this.assetId = dto.assetId
        this.articleId = dto.articleId
        this.articleDescription = dto.articleDescription
        this.lmid = dto.lmid
        this.referenceValue = dto.referenceValue ? new AmountWithCurrency(dto.referenceValue) : undefined
        this.isAssetLabeled = dto.isAssetLabeled
        this.assetVersion = dto.assetVersion
        this.isCurrentVersion = dto.isCurrentVersion
        this.supplierOrderNumber = dto.supplierOrderNumber
        this.internalOrderNumber = dto.internalOrderNumber

    }
}
